/**
 * 页面加载指示器组件
 * 用于路由懒加载时的全局加载状态
 */
import React, { useEffect } from 'react';

const PageLoading = () => {
  // 开发模式下添加最小显示时间，方便测试
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('🔄 PageLoading 组件已挂载');
    }
  }, []);

  return (
    <div className="page-loading-overlay">
      <div className="page-loading-spinner">
        <div className="loading-dots" aria-label="正在加载">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p>加载中...</p>
      </div>
    </div>
  );
};

export default PageLoading;
